import {getMethod, putMethod} from '~/api'

async function get() {
    return await getMethod('/api/turOpConditions')
}

async function put(request) {
    return await putMethod('/api/turOpConditions', request)
}

export {get, put}
